/**
 * V3: Header
 *
 * Controls colour mode switching, from dark to light
 *
 * OUTDATED: This was from when the header was transparent.
 * It's not used anymore, but kept for posterity.
 *
 * @module modules/V3Header
 */


// Dependencies
// ============================================================================

import { $ } from '../common/utility/u-jquery-$';


// Vars
// ============================================================================

const $headerMain    = $( '[data-v3-header-main]' );
const $headerDesktop = $( '[data-v3-header-desktop]' );
const $headerMobile  = $( '[data-v3-header-mobile]' );
const $headerMobNav  = $( '[data-v3-mobilenav-target]' );
const startsLight    = $headerMain.hasClass( 'v3-header--light' ); // no color changes needed if already light


// ƒs
// ============================================================================

/**
 * Core module init
 *
 * @return  {void}
 */
function _moduleInit()
{
	// From when there was an option for `disable_header_transparency`
	makeLight();

	// If the option was disabled, this func would run:
	//// toggleColorModeClass();
}


/**
 * Swaps out the color theme classes on hover or scroll
 *
 * @return  {void}
 */
function toggleColorModeClass()
{
	if ( !$headerMain.length || startsLight )
	{
		return;
	}

	// Hover: Make light
	$headerMain.on( 'mouseenter', () =>
	{
		makeLight();
	});

	// Unhover: Restore dark
	$headerMain.on( 'mouseleave', () =>
	{
		// Header should always be light if the mobile subnav is open,
		// or if the user has already scrolled
		if ( !$headerMobNav.hasClass( 'is-active' ) && !getHasScrolled() )
		{
			makeDark();
		}
	});

	// Make light if the user has scrolled
	if ( getHasScrolled() )
	{
		makeLight();
	}

	$( window ).on( 'scroll', () =>
	{
		if ( getHasScrolled() )
		{
			makeLight();
		}
		else
		{
			if ( !$headerMobNav.hasClass( 'is-active' )  )
			{
				makeDark();
			}
		}
	});
}


/**
 * Remove dark class, add light
 *
 * @return  {void}
 */
function makeLight()
{
	$headerMain.removeClass( $headerMain.data('dark-class') );
	$headerMain.addClass( $headerMain.data('light-class') );
}


/**
 * Remove light class, add dark
 *
 * @return  {void}
 */
function makeDark()
{
	$headerMain.removeClass( $headerMain.data('light-class') );
	$headerMain.addClass( $headerMain.data('dark-class') );
}


/**
 * Check if the page has scrolled yet
 *
 * @return  {boolean}  True if the user has scrolled
 */
function getHasScrolled()
{
	return $( window ).scrollTop() > 0;
}


// Auto Init
// ============================================================================

$( document ).ready( () => _moduleInit() );
